import { el, state } from "./core.js"
import { getCroppedOutputDimensions } from "./crop.js"

let initialized = false
let observer = null

function enforceCropResolution() {
  if (!state.file || !state.mediaReady || !el.statResolution) return
  const dimensions = getCroppedOutputDimensions()
  if (!dimensions.width || !dimensions.height) return
  const expected = `${dimensions.width}×${dimensions.height}`
  if (el.statResolution.textContent !== expected) el.statResolution.textContent = expected
}

export function setupCropMetrics() {
  if (initialized) return
  initialized = true
  queueMicrotask(enforceCropResolution)
  addEventListener("converter-crop-change", enforceCropResolution)
  addEventListener("converter-plan-change", () => requestAnimationFrame(enforceCropResolution))
  observer = new MutationObserver(() => requestAnimationFrame(enforceCropResolution))
  if (el.statResolution) observer.observe(el.statResolution, { childList: true, characterData: true, subtree: true })
}
